import React from 'react';
import { CardContent, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';

import {
  StyledCard,
  FirstContentRow,
  SecondContentRow,
  Location,
  StyledChip,
  Enrolled,
  AnchorTagLink,
  TitleWithLimit,
  DescriptionWithLimit,
} from './styles';
import { OutlineButton } from 'shared-components/Buttons/Outline';
import { ReactComponent as CircleGreenCheckIcon } from 'images/dashboard/circular-green-check.svg';
import { BasicSkeleton, CircleSkeleton } from 'components/SkeletonLoaders';

export const StudyOpportunityCard = ({
  item,
  studyOpportunitiesEntries,
  enrollButtonLoading,
  enrollButtonDisabled,
  onEnroll,
  isLoading,
}) => {
  const theme = useTheme();

  return (
    <StyledCard
      sx={{
        maxWidth : { xs: '100%', lg: '400px' },
        minWidth : '240px',
        flex     : 1,
      }}>
      <CardContent>
        {isLoading
          ? (
            <>
              <BasicSkeleton
                height={25}
              />
              <BasicSkeleton
                height={150}
              />
              <CircleSkeleton
                borderRadius='20px' height={60}
              />
              <BasicSkeleton
                height={70}
              />
            </>
          )
          : (
            <>
              <FirstContentRow>
                <AnchorTagLink
                  target='_blank' href={item.link}>
                  <TitleWithLimit
                    variant='h6'>{item.title}</TitleWithLimit>
                </AnchorTagLink>
                {item.studyLocation.locations.length > 1
                  ? (
                    <Location
                      variant='pl3'>
                      {item.studyLocation.locations.join(', ')}
                    </Location>
                  )
                  : (
                    <Location
                      variant='pl3'>
                      {item.studyLocation.locations[0]}
                    </Location>
                  )}

                <DescriptionWithLimit
                  variant='pl3'>
                  {item.subTitle}
                </DescriptionWithLimit>
                <StyledChip
                  variant='outlined' label='For you'
                />
              </FirstContentRow>
              <SecondContentRow>
                {studyOpportunitiesEntries[item.key]?.toString() === 'true'
                  ? (
                    <Enrolled>
                      <CircleGreenCheckIcon />
                      <Typography
                        variant='pl3'>Enrolled</Typography>
                    </Enrolled>
                  )
                  : (
                    <OutlineButton
                      width='100%'
                      fontFamily='Montserrat'
                      color={theme.palette.primary.blue1}
                      borderColor={theme.palette.primary.blue1}
                      text='Mark as enrolled'
                      onClick={onEnroll}
                      isLoading={enrollButtonLoading}
                      isDisabled={enrollButtonDisabled}
                    />
                  )}
              </SecondContentRow>
            </>
          )}
      </CardContent>
    </StyledCard>
  );
};

export default StudyOpportunityCard;
